import { forwardRef, useEffect, useState } from "react";
import { WidgetProps, WidgetRef } from "../../../types/widget";
import { styles } from "../styles";
import { useThemeStore } from "../../../stores";
import { Column, Row } from "../../containers";
import { Heading } from "../../typography";
import { JustifyContent } from "../../containers/types";
import { addComma } from "../../../utils";
import { TotalSumData } from "./types";
import Api from "../../../api/api";

const TotalSumWidget = forwardRef<WidgetRef, WidgetProps>((props, ref) => {
    const theme = useThemeStore(s => s.theme);

    const [data, setData] = useState<TotalSumData>({
        remaining: 0,
        total_rcvd_cash: 0,
        total_rcvd_cheques: 0,
        total_spent_cash: 0,
        total_spent_cheques: 0,
    });

    useEffect(() => {
        Api.getData<TotalSumData>("/widget/total_sum_chart").then(res => {
            setData(res);
        }).catch(err => {
            console.log(err);
        })
    }, [])

    return (
     <div
      ref={ref}
      style={{
        background: theme.overlay,
        position: "relative",
        ...styles.container,
      }}
      >
        <Row style={{marginBottom: "1rem"}} >
            <Heading color={theme.textOnOverlay} >جمع کل</Heading>
        </Row>

        <Column style={{height: "calc(100% - 32px)"}} justifyContent={JustifyContent.Evenly} gap={5} >
            <Row style={{width: "100%"}} justifyContent={JustifyContent.Between} >
                <Heading color={theme.textOnOverlay} >جمع کل دریافتی چک</Heading>
                <Heading color={theme.textOnOverlay} >{addComma(data.total_rcvd_cheques)}</Heading>
            </Row>

            <Row style={{width: "100%"}} justifyContent={JustifyContent.Between} >
                <Heading color={theme.textOnOverlay} >جمع کل مخارج چک</Heading>
                <Heading color={theme.textOnOverlay} >{addComma(data.total_spent_cheques)}</Heading>
            </Row>

            <Row style={{width: "100%"}} justifyContent={JustifyContent.Between} >
                <Heading color={theme.textOnOverlay} >جمع کل دریافتی نقدی</Heading>
                <Heading color={theme.textOnOverlay} >{addComma(data.total_rcvd_cash)}</Heading>
            </Row>

            <Row style={{width: "100%"}} justifyContent={JustifyContent.Between} >
                <Heading color={theme.textOnOverlay} >جمع کل مخارج نقدی</Heading>
                <Heading color={theme.textOnOverlay} >{addComma(data.total_spent_cash)}</Heading>
            </Row>

            <Row style={{width: "100%"}} justifyContent={JustifyContent.Between} >
                <Heading color={theme.textOnOverlay} >مانده</Heading>
                <Heading color={theme.textOnOverlay} >{addComma(data.remaining)}</Heading>
            </Row>
        </Column>
    </div>
    )
})

export default TotalSumWidget;